@if (props.label) {
  <ion-label [position]="labelPosition">
    {{ props.label }}
    @if (props.required && props['hideRequiredMarker'] !== true) {
      <span aria-hidden="true">*</span>
    }
  </ion-label>
}
